<template>
  <b-row>
    <b-col xs="12">
      <!-- <md-progress-bar v-if="loadingReps" md-mode="indeterminate"></md-progress-bar> -->
      <div v-if="loadingAddNewPerson" class="m-loader">
        <div class="m-loader-icon-holder">
          <i class="m-loader-icon"></i>
          <p></p>
        </div>
      </div>
      <div>
        <b-row>
          <b-col xs="12" md="6">
            <md-card class="island-card">
              <md-card-header>
                <div class="md-title">Legal Structure</div>
              </md-card-header>
              <md-card-content>
              <md-progress-spinner v-if="loadingReps"  :md-diameter="30" :md-stroke="3" md-mode="indeterminate" style="color:white"></md-progress-spinner>

                <md-empty-state
                  v-else-if="!legal_owner_name && !showEditLegalStructure"
                  md-icon="ballot"
                  md-label="Specify The Legal Structure"
                  md-description="This structure will be used in creating the contract."
                >
                  <md-button
                    class="md-primary md-raised play-cta-button makeup"
                    @click="onCreateStructure"
                  >Create Structure</md-button>
                </md-empty-state>
                <md-list class="md-double-line" v-else>
                  <div v-if="legal_owner_name">
                    <md-subheader>Owner</md-subheader>

                    <md-list-item v-if="legal_owner_name">
                      <div class="md-list-item-text">
                        <span>{{legal_owner_name|capitalize}}</span>
                        <span>Name</span>
                      </div>
                    </md-list-item>

                    <md-list-item v-if="legal_owner_id">
                      <div class="md-list-item-text">
                        <span>{{legal_owner_id}}</span>
                        <span>{{legal_owner_id_title}}</span>
                      </div>
                    </md-list-item>
                  </div>

                  <div v-if="legal_rep_name">
                    <md-divider></md-divider>

                    <md-subheader>Represented by</md-subheader>

                    <md-list-item>
                      <div class="md-list-item-text">
                        <span>{{legal_rep_name|capitalize}}</span>
                        <span>Name</span>
                      </div>
                    </md-list-item>

                    <md-list-item v-if="legal_rep_id">
                      <div class="md-list-item-text">
                        <span>{{legal_rep_id}}</span>
                        <span>{{legal_rep_id_title}}</span>
                      </div>
                    </md-list-item>
                  </div>

                  <div v-if="legal_rep_name_priv">
                    <md-divider></md-divider>

                    <md-subheader>Represented in turn by</md-subheader>

                    <md-list-item>
                      <div class="md-list-item-text">
                        <span>{{legal_rep_name_priv|capitalize}}</span>
                        <span>Name</span>
                      </div>
                    </md-list-item>

                    <md-list-item>
                      <div class="md-list-item-text">
                        <span>{{legal_rep_id_priv}}</span>
                        <span>Identification Code</span>
                      </div>
                    </md-list-item>
                  </div>
                </md-list>
              </md-card-content>
              <md-card-actions>
                <moow-button v-if="!showEditLegalStructure && legal_owner_name"
                  :type="['light', 'outlined']" btnText="Edit" @mClick="editLegalStructure"/>
                <!-- <md-button
                  v-if="!showEditLegalStructure && legal_owner_name"
                  class="md-primary md-raised play-cta-button-flat makeup"
                  @click="editLegalStructure()"
                >Edit</md-button> -->
              </md-card-actions>
            </md-card>
          </b-col>
          <b-col xs="12" md="6" v-if="showEditLegalStructure">
            <md-card v-if="!privatePerson">
              <md-card-header>
                <div class="md-title">Missing Account Identity</div>
              </md-card-header>

              <md-card-content>
                <p
                  class="moow-info-txt"
                >Specify your personal identity and if you have, your company details under Account view.</p>
              </md-card-content>
              <md-card-actions>
                <md-button
                  class="md-primary md-raised play-cta-button makeup"
                  @click="addAccountIdentity()"
                >Add Identity</md-button>
              </md-card-actions>
            </md-card>
            <md-card v-else class="island-card">
              <md-card-header>
                <div class="md-title">Owner</div>
                <p class="moow-info-txt">Legal owner of the property</p>
              </md-card-header>
              <md-card-content>
                <toggle-switch
                  btnTitleOn="Third Party"
                  btnTitleOff="Use Account"
                  @emitToggleOn="toggleOwnerIsThirdParty"
                  :initialState="ownerIsThirdParty"
                />

                <div v-if="ownerIsThirdParty">
                  <toggle-switch
                    btnTitleOn="Person"
                    btnTitleOff="Company"
                    @emitToggleOn="toggleOwnerIsPrivatePerson"
                    :initialState="ownerIsThirdPartyPrivPerson"

                  />
                  <div>
                    <private-person-search
                      v-if="ownerIsThirdPartyPrivPerson"
                      ref="privPersonSearchRef"
                      @emitShowSaveIdent="showSetButton"
                    ></private-person-search>
                    <jur-person-search
                      v-else
                      ref="jurPersonSearchRef"
                      :personId="thirdPartyExistingJurPersonId"
                      @emitShowSaveIdent="showSetButton"
                    ></jur-person-search>
                  </div>
                </div>
                <div v-else>
                  <md-checkbox
                    :disabled="!privatePerson"
                    class="md-primary"
                    v-model="useAccountIdentity"
                  >
                    I Am Owner
                    <md-tooltip md-direction="bottom">Manage under Account view</md-tooltip>
                  </md-checkbox>
                  <md-checkbox
                    :disabled="!juridicalPerson"
                    class="md-primary"
                    v-model="useAccountCompany"
                  >
                    My Company Is Owner
                    <md-tooltip md-direction="bottom">Manage under Account view</md-tooltip>
                  </md-checkbox>
                </div>
              </md-card-content>
              <md-card-actions>
                <router-link v-if="!ownerIsThirdParty" to="account" class="footer-nav-item mr-3">
                  <i>Edit Account</i>
                </router-link>

                <moow-button
                  :type="['dark', 'outlined', 'flat']" btnText="Cancel" @mClick="onCancel"/>
                <moow-button
                  :type="['light']" btnText="Set" @mClick="setLegalStructure" v-if="showSet"/>
                
              </md-card-actions>
            </md-card>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>
<script>
import ToggleSwitch from "@/components/interface/buttons/toggleSwitch.vue";
import { moowLog } from "@/utils/logging/logService";
import { getPropertyRepresentatives } from "@/platform/properties/services/propertyService.js";
import { formatDateToString } from "@/timeFunctions.js";
import PrivatePersonSearch from "@/components/person/privatePersonSearch.vue";
import JuridicalPersonSearch from "@/components/person/juridicalPersonSearch.vue";
import { captureMessage, captureException } from "@/utils/reporting/reportingService.js";
import {
  upsertPrivatePerson,
  upsertJurPerson
} from "@/platform/person/repository/personRepository";
import {
  getJuridicalPerson,
  getPrivatePerson
} from "../../platform/person/repository/personRepository";
export default {
  props: {
    propertyId: {
      type: String,
      required: true
    }
  },
  components: {
    "private-person-search": PrivatePersonSearch,
    "jur-person-search": JuridicalPersonSearch,
    "toggle-switch": ToggleSwitch
  },
  data() {
    return {
      showEditLegalStructure: false,
      loadingAddNewPerson: false,
      ownerIsThirdParty: false,
      ownerIsThirdPartyPrivPerson: false,
      useAccountIdentity: false,
      useAccountCompany: false,
      selectedJurPersonId: undefined,
      loadingReps: false,
      representatives: {
        ownerEmail: "",
        ownerAddress: "",
        ownerIdent: "",
        ownerName: "",
        ownerPersonType: "",
        ownerPersonId: "",
        repPrivPersonId: "",
        repJurPersonId: "",
        repName: "",
        repId: "",
        repPersonType: "",
        repPrivName: "",
        repPrivId: ""
      },
      thirdPartyExistingJurPersonId: undefined,
      showSet: false
    };
  },

  created() {
    this.getPropertyRepresentatives(this.propertyId);
  },
  mounted() {},
  watch: {
    useAccountIdentity: function(val) {
      if (!val) this.useAccountCompany = false;
    }
  },
  computed: {
    accountJuridicalPerson() {
      if (this.$store.getters.jurPersons.length == 0) return false;
      else return this.$store.getters.jurPersons[0];
    },
    accountPrivatePerson() {
      if (this.$store.getters.privatePerson) return false;
      else return this.$store.getters.privatePerson;
    },
    legal_rep_name_priv() {
      return this.representatives.repPrivName;
    },
    legal_rep_id_priv() {
      return this.representatives.repPrivId;
    },
    legal_owner_name() {
      return this.representatives.ownerName;
    },
    legal_owner_id() {
      return this.representatives.ownerIdent;
    },
    legal_owner_id_title() {
      if (this.representatives.ownerPersonType == "private")
        return "Identification Code";
      else return "Registration Nr";
    },
    legal_rep_name() {
      return this.representatives.repName;
    },
    legal_rep_id() {
      return this.representatives.repId;
    },
    legal_rep_id_title() {
      if (this.representatives.repPersonType == "private")
        return "Identification Code";
      else return "Registration Nr";
    },
    thirPartOwnerType() {
      if (this.ownerIsThirdPartyPrivPerson) return "Private Person";
      else return "Company";
    },
    privPersonId() {
      return this.representatives.privPersonId;
    },
    jurPersonId() {
      return this.representatives.jurPersonId;
    },
    jurThirdPartyPerson() {
      return this.representatives.jurThirdPartyPerson;
    },
    editPrivatePersonBtnTxt() {
      if (this.representatives.privPersonId) return "Edit";
      else return "Add";
    },
    editJurPersonBtnTxt() {
      if (this.representatives.jurPersonId) return "Edit";
      else return "Add";
    },
    editJurThirdPersonBtnTxt() {
      if (this.representatives.jurThirdPartyPerson) return "Edit";
      else return "Add";
    },
    juridicalPerson() {
      if (this.$store.getters.jurPersons.length == 0) return false;
      else return this.$store.getters.jurPersons[0];
    },
    privatePerson() {
      if (!this.$store.getters.privatePerson._id) return false;
      else return this.$store.getters.privatePerson;
    },
    privatePerson_name() {
      if (this.privatePerson && this.privatePerson.givenName) {
        return (
          this.capitalize(this.privatePerson.givenName) +
          " " +
          this.capitalize(this.privatePerson.surname)
        );
      } else return "";
    },
    privatePerson_id() {
      if (!this.privatePerson) return "";
      if (this.privatePerson.idCode) return this.privatePerson.idCode;
      else return this.privatePerson.ssnTaxNr;
    },
    privatePerson_dob() {
      if (this.privatePerson && this.privatePerson.dob)
        return formatDateToString(this.privatePerson.dob, "YYYY/MM/DD");
      else return "";
    }
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  methods: {
    showSetButton(value){
      this.showSet = value
    },
    editLegalStructure() {
      this.showEditLegalStructure = true;
      this.toggleOwnerIsThirdParty(this.ownerIsThirdParty);
      this.toggleOwnerIsPrivatePerson(this.ownerIsThirdPartyPrivPerson);
    },
    ifLegalStructureSet() {},
    setLegalStructure() {
      if (this.ownerIsThirdParty) {
        if (this.ownerIsThirdPartyPrivPerson) this.setThirdPartyPrivOwner();
        else this.setThirdPartyJurOwner();
      } else {
        this.toggleUseAccountIdentity(this.useAccountIdentity);
        this.toggleUseAccountCompany(this.useAccountCompany);
        this.emitLegalStructure("setLegalStructure");
      }
    },
    emitLegalStructure(emitFunctionName) {
      var legalStructure = this.makeLegalStructureCommand(this.representatives);
      this.showEditLegalStructure = false;
      this.$emit(emitFunctionName, legalStructure);
    },
    toggleOwnerIsPrivatePerson(value) {
      this.ownerIsThirdPartyPrivPerson = value;
      this.showSet = false
    },
    toggleOwnerIsThirdParty(value) {
      if(value)
        this.showSet = false
      else 
        this.showSet = true
      this.ownerIsThirdParty = value;
      this.useAccountIdentity = false;
      this.useAccountCompany = false;
    },
    setThirdPartyPrivOwner() {
      var validPerson = this.$refs.privPersonSearchRef.getValidPerson();
      if (validPerson) {
        var ident;
        validPerson.idCode
          ? (ident = validPerson.idCode)
          : (ident = validPerson.ssnTaxNr);
        this.setCompexModel(
          validPerson._id,
          validPerson.givenName + " " + validPerson.surname,
          validPerson.email,
          validPerson.address,
          ident,
          "private",
          upsertPrivatePerson({person:validPerson})
        );
      }
    },
    setThirdPartyJurOwner() {
      var validPerson = this.$refs.jurPersonSearchRef.getValidPerson();
      console.log("setThirdPartyJurOwner | validPerson:", validPerson);
      if (validPerson) {
        this.setCompexModel(
          validPerson._id,
          validPerson.name,
          validPerson.email,
          validPerson.address,
          validPerson.regNr,
          "juridical",
          upsertJurPerson({person: validPerson})
        );
      }
    },
    setCompexModel(
      thirdPartyId,
      thirdPartyName,
      thirdPartyEmail,
      thirdPartyAddress,
      thirdPartyIdent,
      thirPartyType,
      thirdPartyGetPromise
    ) {
      var idPromise;
      if (thirdPartyId) idPromise = Promise.resolve({ personId: thirdPartyId });
      else idPromise = thirdPartyGetPromise;

      this.loadingAddNewPerson = true;
      idPromise
        .then(resp => {
          this.representatives.ownerPersonId = resp.personId;
          this.setComplexOwnershipModelBasedOn(
            thirdPartyName,
            thirdPartyIdent,
            thirPartyType,
            thirdPartyEmail,
            thirdPartyAddress
          );
          this.setComplexRepresentationModelBasedOnAccount();
          this.emitLegalStructure("setLegalStructure");
        })
        .catch(err => {})
        .finally(r => {
          this.loadingAddNewPerson = false;
        });
    },
    setComplexOwnershipModelBasedOn(
      ownerName,
      ownerIdent,
      personType,
      ownerEmail,
      ownerAddress
    ) {
      this.representatives.ownerPersonType = personType;
      this.representatives.ownerName = ownerName;
      this.representatives.ownerIdent = ownerIdent;
      this.representatives.ownerEmail = ownerEmail;
      this.representatives.ownerAddress = ownerAddress;
    },
    setComplexRepresentationModelBasedOnAccount() {
      this.representatives.repPrivPersonId = this.privatePerson._id;

      if (this.juridicalPerson) {
        this.representatives.repJurPersonId = this.juridicalPerson._id;
        this.representatives.repName = this.juridicalPerson.name;
        this.representatives.repId = this.juridicalPerson.regNr;
        this.representatives.repPersonType = "juridical";

        this.representatives.repPrivName = this.privatePerson_name;
        this.representatives.repPrivId = this.privatePerson_id;
      } else {
        this.representatives.repName = this.privatePerson_name;
        this.representatives.repId = this.privatePerson_id;
        this.representatives.repPersonType = "private";
        this.representatives.repJurPersonId = "";
        this.representatives.repPrivName = "";
        this.representatives.repPrivId = "";
      }
      this.representatives.repEmail = this.privatePerson.emails[0];
      this.representatives.repAddress = this.privatePerson.address;
    },
    // repPrivPersonId: representatives.repPrivPersonId,
    // repJurPersonId: representatives.repJurPersonId

    toggleUseAccountIdentity(use) {
      if (use == false) {
        this.useAccountCompany = false; // cannot use account company wo/ identity
        this.representatives.ownerPersonType = "";
        this.representatives.ownerPersonId = "";
        this.representatives.repPrivPersonId = "";
        this.representatives.repJurPersonId = "";
        this.representatives.ownerName = "";
        this.representatives.ownerIdent = "";
        this.representatives.repName = "";
        this.representatives.repId = "";
        this.representatives.repEmail = "";
        this.representatives.repAddress = "";
        this.representatives.ownerEmail = "";
        this.representatives.ownerAddress = "";
      } else {
        this.representatives.ownerPersonType = "private";
        this.representatives.ownerPersonId = this.privatePerson._id;
        this.representatives.repPrivPersonId = this.privatePerson._id;
        this.representatives.repJurPersonId = "";
        this.representatives.ownerName = this.privatePerson_name;
        this.representatives.ownerIdent = this.privatePerson_id;
        this.representatives.repName = this.privatePerson_name;
        this.representatives.repId = this.privatePerson_id;
        this.representatives.repEmail = this.privatePerson.emails[0];
        this.representatives.repAddress = this.privatePerson.address;
        this.representatives.ownerEmail = this.privatePerson.emails[0];
        this.representatives.ownerAddress = this.privatePerson.address;
      }
      this.representatives.repPrivId = "";
      this.representatives.repPrivName = "";
      //this.updateLegalStructure(this.representatives);
    },
    toggleUseAccountCompany(use) {
      if (use == true) {
        this.useAccountIdentity = true;
        this.representatives.ownerPersonType = "juridical";
        this.representatives.ownerPersonId = this.juridicalPerson._id;
        this.representatives.repPrivPersonId = this.privatePerson._id;
        this.representatives.repJurPersonId = "";
        this.representatives.ownerName = this.juridicalPerson.name;
        this.representatives.ownerIdent = this.juridicalPerson.regNr;
        this.representatives.repName = this.privatePerson_name;
        this.representatives.repId = this.privatePerson_id;
        this.representatives.repPrivId = "";
        this.representatives.repPrivName = "";
        this.representatives.ownerEmail = this.juridicalPerson.emails[0];
        this.representatives.ownerAddress = this.juridicalPerson.addresses[0];
      } else {
        this.representatives.ownerPersonType = "private";
        this.representatives.ownerPersonId = this.privatePerson._id;
        this.representatives.repPrivPersonId = this.privatePerson._id;
        this.representatives.repJurPersonId = "";
        this.representatives.ownerName = this.privatePerson_name;
        this.representatives.ownerIdent = this.privatePerson_id;
        this.representatives.repName = this.privatePerson_name;
        this.representatives.repId = this.privatePerson_id;
        this.representatives.ownerEmail = this.privatePerson.emails[0];
        this.representatives.ownerAddress = this.privatePerson.address;
      }
      this.representatives.repEmail = this.privatePerson.emails[0];
      this.representatives.repAddress = this.privatePerson.address;
      this.representatives.repPrivId = "";
      this.representatives.repPrivName = "";
      //this.updateLegalStructure(this.representatives);
    },
    addAccountCompany() {
      this.redirectTo("account", { openWithTab: "tab-company" });
    },
    addAccountIdentity() {
      this.redirectTo("account");
    },
    addOwner(type) {
      if ((type = "private")) {
        this.ownerIsThirdPartyPrivPerson = true;
      } else {
        this.ownerIsThirdPartyPrivPerson = false;
      }
    },
    getPropertyRepresentatives(propertyId) {
      this.loadingReps = true;
      getPropertyRepresentatives(propertyId)
        .then(resp => {
          this.mapRepresentativesToForm(resp);
        })
        .catch(err => {
          captureException(err)
          this.loadingReps = false;
        })
        .finally(f => {});
    },
    mapRepresentativesToForm(reps) {
      if (reps) {
        var ownerPersonPromise;
        if (
          reps.ownerPersonId &&
          reps.ownerPersonType &&
          reps.ownerPersonType == "juridical"
        )
          ownerPersonPromise = getJuridicalPerson({ id: reps.ownerPersonId });
        else if (
          reps.ownerPersonId &&
          reps.ownerPersonType &&
          reps.ownerPersonType == "private"
        )
          ownerPersonPromise = getPrivatePerson({ id: reps.ownerPersonId });
        else ownerPersonPromise = Promise.resolve();

        var repPrivPersonPromise;
        if (reps.repPrivPersonId)
          repPrivPersonPromise = getPrivatePerson({ id: reps.repPrivPersonId });
        else repPrivPersonPromise = Promise.resolve();

        var repJurPersonPromise;
        if (reps.repJurPersonId)
          repJurPersonPromise = getJuridicalPerson({ id: reps.repJurPersonId });
        else repJurPersonPromise = Promise.resolve();

        this.loadingReps = true;

        Promise.all([
          ownerPersonPromise,
          repPrivPersonPromise,
          repJurPersonPromise
        ])
          .then(results => {
            // if owner found
            if (results[0]) {
              this.representatives.ownerPersonId = this.representatives.ownerName =
                results[0]._id;

              results[0].name
                ? (this.representatives.ownerName = results[0].name)
                : (this.representatives.ownerName =
                    results[0].givenName + " " + results[0].surname);
              if (results[0].regNr) {
                this.representatives.ownerIdent = results[0].regNr;
                this.representatives.ownerPersonType = "juridical";
                this.representatives.ownerAddress = results[0].addresses[0];
              } else {
                results[0].idCode
                  ? (this.representatives.ownerIdent = results[0].idCode)
                  : (this.representatives.ownerIdent = results[0].ssnTaxNr);
                this.representatives.ownerPersonType = "private";
                this.representatives.ownerAddress = results[0].address;
              }
              this.representatives.ownerEmail = results[0].emails[0];
            }

            // if complex legal strucuture
            if (results[2]) {
              this.representatives.repPrivPersonId = results[1]._id;
              this.representatives.repJurPersonId = results[2]._id;

              this.representatives.repName = results[2].name;
              this.representatives.repId = results[2].regNr;
              this.representatives.repPersonType = "juridical";
              this.representatives.repPrivName =
                results[1].givenName + " " + results[1].surname;
              results[1].idCode
                ? (this.representatives.repPrivId = results[1].idCode)
                : (this.representatives.repPrivId = results[1].ssnTaxNr);
            } else {
              // simple
              this.representatives.repPrivPersonId = results[1]._id;
              this.representatives.repJurPersonId = "";
              this.representatives.repPrivId = "";
              this.representatives.repPrivName = "";

              this.representatives.repPersonType = "private";
              this.representatives.repName =
                results[1].givenName + " " + results[1].surname;
              results[1].idCode
                ? (this.representatives.repId = results[1].idCode)
                : (this.representatives.repId = results[1].ssnTaxNr);
            }
            // REPS
            this.representatives.repEmail = this.privatePerson.emails[0];
            this.representatives.repAddress = this.privatePerson.address;

            // Create existing person dao
            this.thirdPartyExistingJurPersonId = this.mapRepresentativesToJurPersonEditForm(
              this.representatives
            );
          })
          .catch(err => {
            // no representative found
          })
          .finally(f => {
            this.loadingReps = false;
            this.emitLegalStructure("legalStructureUpdated");
          });
      }
    },
    mapRepresentativesToJurPersonEditForm(representatives) {
      var thirdPartyJurPersonId;

      if (representatives.ownerPersonType == "juridical") {
        if (representatives.ownerPersonId == this.accountJuridicalPerson.id) {
          this.ownerIsThirdParty = false;
          this.useAccountCompany = true;
          this.useAccountIdentity = true;
        } else {
          this.ownerIsThirdParty = true;
          this.ownerIsThirdPartyPrivPerson = false;
          thirdPartyJurPersonId = representatives.ownerPersonId;
        }
      } else {
        if (representatives.ownerPersonId == this.accountPrivatePerson.id) {
          this.ownerIsThirdParty = false;
          this.useAccountCompany = false;
          this.useAccountIdentity = true; // has to be true, otherwise there wouldn't be any legal structure
        } else {
          this.ownerIsThirdParty = true;
          this.ownerIsThirdPartyPrivPerson = true;
          // TODO: return makeExistingThirdPartyPrivPerson(representatives)
        }
      }

      return thirdPartyJurPersonId;
    },
    redirectTo(where, params) {
      this.$router.push({
        name: where,
        params: params
      });
    },
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    makeLegalStructureCommand(representatives) {
      return {
        propertyId: this.propertyId,
        ownerPersonType: representatives.ownerPersonType,
        ownerPersonId: representatives.ownerPersonId,
        repPrivPersonId: representatives.repPrivPersonId,
        repJurPersonId: representatives.repJurPersonId,
        repEmail: representatives.repEmail,
        repAddress: representatives.repAddress,
        ownerEmail: representatives.ownerEmail,
        ownerAddress: representatives.ownerAddress
      };
    },
    onCreateStructure() {
        this.showEditLegalStructure = true;
        this.$emit('structureCreationEngaged');
    },
    onCancel() {
        this.showEditLegalStructure = false;
        this.$emit('structureEditingCanceled');
    },
  }
};
</script>
<style scoped>
@import "../../assets/styles/global.css";

.highlighted {
  color: white;
  background-color: #4589fa;
}
</style>



// WEBPACK FOOTER //
// src/components/property/propertyRepSelector.vue